<template>
  <modal
    :clickaway-enabled="false"
    class="edit-response-set-modal"
    @modal-close="handleClose"
  >
    <div class="edit-response-set-modal__container">
      <div class="edit-response-set-modal__box">
        <DropdownResponseSet
          v-if="isDropdown"
          ref="responseSetComponent"
          :temporary-response-set="temporaryResponseSet"
          @deleteResponse="deleteResponse"
          @addResponseAfter="addResponseAfter"
          @close="handleClose"
          @addResponse="addResponseAfter"
          @manualTitlesChanged="manualTitlesChanged"
        />

        <ListResponseSet
          v-else
          ref="responseSetComponent"
          :temporary-response-set="temporaryResponseSet"
          @deleteResponse="deleteResponse"
          @addResponseAfter="addResponseAfter"
          @manualTitlesChanged="manualTitlesChanged"
        />

        <div v-if="!isDropdown" style="margin-top: 2.5rem">
          <label class="block text-90 mb-2" :class="{ 'opacity-50': isTranslationMode}">
            {{ $t('Title (optional)') }}
          </label>
          <input
            v-model="temporaryResponseSet.title"
            type="text"
            class="w-full form-control form-input form-input-bordered"
            :disabled="isTranslationMode"
          >
        </div>
      </div>

      <div class="bg-30 px-6 py-3 flex rounded-lg rounded-t-none">
        <div class="ml-auto">
          <button
            type="button"
            class="btn text-80 font-normal h-9 px-3 mr-3 btn-link"
            @click.prevent="handleClose"
          >
            {{ $t('Cancel') }}
          </button>
          <button
            type="submit"
            class="btn btn-default btn-primary"
            @click.prevent="handleSave"
          >
            {{ $t('Save') }}
          </button>
        </div>
      </div>
    </div>

  </modal>
</template>

<script>
  import ListResponseSet from '@/_legacy/views/ChecklistBuilder/Build/Modals/ListResponseSet';
  import DropdownResponseSet from '@/_legacy/views/ChecklistBuilder/Build/Modals/DropdownResponseSet';
  import { t } from '@/ui/i18n/i18n';
  import { useManualTranslationsStore } from '@/stores/checklist/manualTranslations';
  import emitter from '@/services/emitter';

  export default {
    components: {
      ListResponseSet,
      DropdownResponseSet,
    },
    data() {
      return {
        temporaryResponseSet: {},
        manualTitles: new Map(),
      };
    },
    computed: {
      editedResponseSet() {
        return this.$store.getters['checklist_builder/edit_response_set_modal'].response_set;
      },
      editedType() {
        return this.$store.getters['checklist_builder/edit_response_set_modal'].type;
      },
      isTranslationMode() {
        return this.$store.getters['checklist_builder/edit_response_set_modal'].isTranslationMode;
      },
      isDropdown() {
        return this.editedType === 'dropdown';
      },
      hasEmptyAnswerTitle() {
        return this.temporaryResponseSet.responses.some(response => response.title === '');
      },
      hasEmptyTitle() {
        return this.temporaryResponseSet.title === '';
      }
    },
    /**
     * Mount the component.
     */
    created() {
      if (this.editedResponseSet) {
        this.temporaryResponseSet = JSON.parse(JSON.stringify(this.editedResponseSet));
      } else {
        this.temporaryResponseSet = {
          type: this.editedType,
          title: this.isDropdown ? '' : undefined,
          responses: [{
            title: '',
            color: '#777777',
            score: null,
            negative: false,
          }],
        };
      }
    },
    methods: {
      addResponse() {
        this.temporaryResponseSet.responses.push({
          title: '',
          color: '#777777',
          score: null,
          negative: false,
        });
      },
      deleteResponse(index) {
        this.temporaryResponseSet.responses.splice(index, 1);
      },
      addResponseAfter(index) {
        index = parseInt(index) + 1;

        this.temporaryResponseSet.responses.splice(index, 0, {
          title: '',
          color: '#777777',
          score: null,
          negative: false,
        });
      },
      setManualTranslations() {
        const store = useManualTranslationsStore();
        const filtered = new Map(Array.from(this.manualTitles).filter(([key, value]) => value !== null));

        this.temporaryResponseSet.responses?.forEach(response => {
          if (filtered.has(response.uuid)) {
            store.setTranslationTitle(
              response.node_id,
              response.uuid,
              filtered.get(response.uuid),
              response.title_translated ?? '',
            );
          }
        });
      },
      handleClose() {
        this.manualTitles = new Map();
        this.$emit('close');
      },
      handleSave() {
        if (this.isTranslationMode) {
          this.setManualTranslations();
          emitter.emit('responseSetTranslationUpdated', this.temporaryResponseSet.uuid);
          this.$emit('close');

          return;
        }

        if (this.hasEmptyAnswerTitle || this.hasEmptyTitle) {
          this.$toasted.error(
            this.isDropdown
              ? t('template-builder.dropdown.empty-answer-title')
              : t('template-builder.multiple-choice.empty-answer-title')
          );

          return;
        }

        this.$store.dispatch('checklist_builder/saveResponseSet', {
          responseSet: this.temporaryResponseSet,
        });
        this.$emit('close');
      },
      manualTitlesChanged(manualTitles) {
        this.manualTitles = manualTitles;
      },
    },
  };
</script>
